import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Body1Strong, makeStyles, tokens } from "@fluentui/react-components";
import { AddRegular, CopyRegular, DeleteRegular } from "@fluentui/react-icons";
import { ButtonLine } from "../hoc/buttonLine";
const useListStyles = makeStyles({
    item: {
        width: "100%",
        display: "flex",
        flexDirection: "row", // Arrange items horizontally
        alignItems: "center", // Center items vertically
        gap: tokens.spacingHorizontalS, // Add space between elements
        borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    },
    itemId: {
        width: tokens.spacingHorizontalM,
    },
    itemContent: {
        flex: 1, // Take up remaining space
        minWidth: 0, // Prevent flex item from overflowing
    },
    iconContainer: {
        display: "flex",
        gap: tokens.spacingHorizontalXS, // Small gap between icons
        alignItems: "center",
        flexShrink: 0, // Prevent shrinking
    },
    list: {
        padding: tokens.spacingVerticalS,
    },
});
/**
 * For cases where you may want to add / remove items from a list via a trash can button / copy button, this HOC can be used
 * @returns A React component that renders a list of items with add/delete functionality
 * @param props - The properties for the List component
 */
export function List(props) {
    const { items, renderItem, onDelete, onAdd, addButtonLabel = "Add new item" } = props;
    const classes = useListStyles();
    const sortedItems = useMemo(() => [...items].sort((a, b) => a.sortBy - b.sortBy), [items]);
    return (_jsxs("div", { children: [onAdd && _jsx(ButtonLine, { label: addButtonLabel, icon: AddRegular, onClick: () => onAdd() }), _jsx("div", { className: classes.list, children: sortedItems.map((item, index) => (_jsxs("div", { className: classes.item, children: [_jsxs(Body1Strong, { className: classes.itemId, children: ["#", index] }), _jsx("div", { className: classes.itemContent, children: renderItem(item, items.indexOf(sortedItems[index])) }), (onAdd || onDelete) && (_jsxs("div", { className: classes.iconContainer, children: [onAdd && _jsx(CopyRegular, { onClick: () => onAdd(item) }), onDelete && _jsx(DeleteRegular, { onClick: () => onDelete(item, items.indexOf(sortedItems[index])) })] }))] }, item.id))) })] }));
}
//# sourceMappingURL=list.js.map